var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { httpGet, httpPost, httpPut } from "./request/requestApi";
const controllerEndpoint = "report";
export class TrackedItemTypeApi {
    static mapReportTypeResponse(response) {
        if (!response) {
            return [];
        }
        if (Array.isArray(response === null || response === void 0 ? void 0 : response.content)) {
            return response.content;
        }
        return [];
    }
    static searchReportTypes(params) {
        const { page = 0, size = 20, systemCreated, isHidden, keyword, searchType, sort, } = params;
        const queryParams = {
            page,
            size,
            systemCreated,
            isHidden,
            sort,
        };
        const trimmedKeyword = keyword === null || keyword === void 0 ? void 0 : keyword.trim();
        if (trimmedKeyword) {
            queryParams.keyword = trimmedKeyword;
            queryParams.searchType = searchType !== null && searchType !== void 0 ? searchType : "reportTypeName";
        }
        return httpGet(`els/report-types/search`, { params: queryParams });
    }
    static getTrackedItemTypes(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield TrackedItemTypeApi.searchReportTypes({
                page: options.page,
                size: options.size,
                systemCreated: false,
                isHidden: false,
                keyword: options.keyword,
                searchType: options.searchType,
                sort: options.sort,
            });
            // Return full response when page/size are provided for pagination
            if (options.page !== undefined || options.size !== undefined) {
                return response;
            }
            return TrackedItemTypeApi.mapReportTypeResponse(response);
        });
    }
    static getDefaultsByFrequency(frequency, type) {
        return httpGet(`${controllerEndpoint}/typesByFrequency/${frequency}/${type}`);
    }
    static getSystemCreatedTrackedItemTypes(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield TrackedItemTypeApi.searchReportTypes({
                page: options.page,
                size: options.size,
                systemCreated: true,
                isHidden: false,
                keyword: options.keyword,
                searchType: options.searchType,
                sort: options.sort,
            });
            // Return full response when page/size are provided for pagination
            if (options.page !== undefined || options.size !== undefined) {
                return response;
            }
            return TrackedItemTypeApi.mapReportTypeResponse(response);
        });
    }
    static getHiddenTrackedItemTypes(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield TrackedItemTypeApi.searchReportTypes({
                page: options.page,
                size: options.size,
                systemCreated: false,
                isHidden: true,
                keyword: options.keyword,
                searchType: options.searchType,
                sort: options.sort,
            });
            // Return full response when page/size are provided for pagination
            if (options.page !== undefined || options.size !== undefined) {
                return response;
            }
            return TrackedItemTypeApi.mapReportTypeResponse(response);
        });
    }
    static createTrackedItemType(data) {
        return httpPost(`${controllerEndpoint}/createReportType`, {
            body: data,
        });
    }
    static updateTrackedItemType(data) {
        return httpPut(`${controllerEndpoint}/updateReportType`, {
            body: data,
        });
    }
    static activateTrackedItemType(id) {
        return httpPost(`${controllerEndpoint}/enableReportType/${id}`);
    }
    static inActivateTrackedItemType(id) {
        return httpPost(`${controllerEndpoint}/disableReportType/${id}`);
    }
    static getTrackedItemTypeBySite(siteId, systemCreated, isHidden) {
        return httpGet(`${controllerEndpoint}/filteredTypes/${siteId}/${systemCreated}/${isHidden}`);
    }
    static getCategoryDataforIndices(categoryId) {
        return httpGet(`${controllerEndpoint}/getCategoryDefaultData/${categoryId}`);
    }
    static getCategoryDefaultData(categoryId) {
        return httpGet(`${controllerEndpoint}/getCategoryDataAndCreatedSubCategories/${categoryId}`);
    }
    static getTopicsForIndices(subcategoryId) {
        return httpGet(`${controllerEndpoint}/getTopicsForIndices/${subcategoryId}`);
    }
    static getCreatedTopics(subcategoryId) {
        return httpGet(`${controllerEndpoint}/getCreatedTopics/${subcategoryId}`);
    }
    static getCategoryDefaults() {
        return httpGet(`${controllerEndpoint}/getAllCreatedCategoryDefaults`);
    }
    static getHiddenDefaultsDetail() {
        return httpGet(`${controllerEndpoint}/listComponentsNameAndType`);
    }
}
